import React from 'react';

const Resume = props => {
    return (
        <div className="scroll_y fixedheight">
            <h1>Aspiring Web Developer</h1>
            <h3>Technical Skills</h3>
                <ul>
                    <li><b>Front-End Web: </b>React, Javascript, HTML5, CSS</li>
                    <li><b>Back-End Web: </b>Node.js, Express, MongoDB / Mongoose, MySQL, Postgres</li>
                    <li><b>Workflow and Version Control: </b> Git, GitHub, JIRA</li>
                </ul>

            <h3>Technical Projects</h3>
                <ul>
                    <li><b>AllAboutFifthWheels.com </b><a href="https://www.allaboutfifthwheels.com">www.AllAboutFifthWheels.com</a></li>
                    <li><b>Back-End Web: </b>Node.js, Express, MongoDB / Mongoose, MySQL, Postgres</li>
                    <li><b>Workflow and Version Control: </b> Git, GitHub, JIRA</li>
                </ul>

            <h3>Professional Experience</h3>
                <ul>
                    <li><b>Front-End Web Development:</b>React, Javascript, HTML5, CSS</li>
                    <li><b>Back-End Web Development:</b>Node.js, Express, MongoDB / Mongoose, MySQL, Postgres</li>
                    <li><b>Workflow and Version Control:</b> Git, GitHub, JIRA</li>
                </ul>
            <h3>Training, Education, and Licenses</h3>
                <ul>
                    <li><b>Coding Dojo:</b><i>Sep. 2020-Dec. 2020</i>MERN Black Belt</li>
                    <li><b>University of Houston Law Center</b><i>Aug. 2003-May 2006, Aug. 2007- May 2008</i>Master of Laws, Taxation (May 2008); Juris Doctor (May 2006)</li>
                    <li><b>Coding Dojo:</b><i>Sep. 2020-Dec. 2020</i>MERN Black Belt</li>
                </ul>

                    <ul>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
                <li>
                    <h3>Social Equity / Diversity, Equity, and Inclusion</h3>
                    <p>Write up on why DEI matters.</p>
                    <p>Write up on how I have been involved with DEI.</p>
                </li>
            </ul>

        </div>
    )
}

export default Resume;